import React from "react";
import Popular_sidebar from "./popular-component";
import Category_sidebar from "./category-component";
import Tag_sidebar from "./tag-component";

function Blog_sidebar(){
    return(
        <div className="sidebar">
            <Popular_sidebar />
            <Category_sidebar />
            <Tag_sidebar />
        </div>
    );
}

export default Blog_sidebar;